(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-long-description"] && !window.DesignMode) return;
  try {
    
  const description = document.querySelector('.collection-long-description');
  const descriptionBtn = document.querySelector('.collection-long-description-btn');
  descriptionBtn.addEventListener('click', () => {
    const hasClass = description.classList.value.includes('.collection-long-description-show');
    description.classList.toggle('collection-long-description-show');
    descriptionBtn.classList.toggle('less');
  });

  } catch(e) { console.error(e); }
})();
})();
